import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Row, Col } from 'antd'

import Provider from 'model/provider/provider'
import { PROVIDERS_PATH } from 'constants/routes'

import {
  Address,
  Bold,
  AdditionalLocations,
  ConfidenceRating
} from 'ui/entities/styled'

const ProviderAddress = ({ provider, isSelectionMode = false }) => {
  const address = provider.getClosestAddress
  const { addresses } = provider

  if (!address) return null

  return (
    <>
      <Row
        data-test="providerAddress"
        justify={isSelectionMode ? 'start' : 'end'}
      >
        <Col>
          <Address alignLeft={isSelectionMode} offsetTop={isSelectionMode}>
            {!isSelectionMode && (
              <Bold data-test="providerAddressDistance">
                {address?.distance ? `${address.distance} mi · ` : ''}
              </Bold>
            )}
            {address?.address}
          </Address>
          <Address alignLeft={isSelectionMode}>{address?.phone}</Address>
          <AdditionalLocations
            alignLeft={isSelectionMode}
            href={`${PROVIDERS_PATH}/${provider.id}`}
          >
            {addresses &&
              addresses.length &&
              addresses.length > 1 &&
              `${addresses.length - 1} other location${
                addresses.length > 2 ? 's' : ''
              }`}
          </AdditionalLocations>
        </Col>
        <Col>
          <Tooltip title={`Location Confidence Level ${address?.confidence}`}>
            <ConfidenceRating
              data-test="providerAddressConfidence"
              green={(address?.confidence > 2).toString()}
              offsetTop={isSelectionMode}
            >
              {address?.confidence}
            </ConfidenceRating>
          </Tooltip>
        </Col>
      </Row>
      {isSelectionMode && (
        <Row>
          <Col>
            <Address alignLeft>
              <Bold data-test="providerAddressDistance">
                {address?.distance ? `${address.distance} mi` : ''}
              </Bold>
            </Address>
          </Col>
        </Row>
      )}
    </>
  )
}

ProviderAddress.propTypes = {
  provider: PropTypes.instanceOf(Provider).isRequired,
  isSelectionMode: PropTypes.bool
}

export default ProviderAddress
